import * as i0 from '@angular/core';
import * as i1 from './aws-amplify-angular.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from './directives/dynamic.component.directive';
import * as i5 from './components/authenticator/authenticator/authenticator.factory';
import * as i6 from './components/authenticator/authenticator/authenticator.component.core';
import * as i7 from './components/authenticator/confirm-sign-in-component/confirm-sign-in.factory';
import * as i8 from './components/authenticator/confirm-sign-in-component/confirm-sign-in-component.core';
import * as i9 from './components/authenticator/confirm-sign-up-component/confirm-sign-up.factory';
import * as i10 from './components/authenticator/confirm-sign-up-component/confirm-sign-up.component.core';
import * as i11 from './components/authenticator/sign-in-component/sign-in.component.factory';
import * as i12 from './components/authenticator/sign-in-component/sign-in.component.core';
import * as i13 from './components/authenticator/sign-up-component/sign-up.factory';
import * as i14 from './components/authenticator/sign-up-component/sign-up.component.core';
import * as i15 from './components/authenticator/require-new-password-component/require-new-password.factory';
import * as i16 from './components/authenticator/require-new-password-component/require-new-password.component.core';
import * as i17 from './components/authenticator/greeting-component/greeting.factory';
import * as i18 from './components/authenticator/greeting-component/greeting.component.core';
import * as i19 from './components/authenticator/forgot-password-component/forgot-password.factory';
import * as i20 from './components/authenticator/forgot-password-component/forgot-password.component.core';
import * as i21 from './components/authenticator/username-field-component/username-field.component.core';
import * as i22 from './components/authenticator/phone-field-component/phone-field.component.core';
import * as i23 from './components/storage/s3-album-component/s3-album.factory';
import * as i24 from './components/storage/s3-album-component/s3-album.component.core';
import * as i25 from './components/storage/s3-image-component/s3-image.factory';
import * as i26 from './components/storage/s3-image-component/s3-image.component.core';
import * as i27 from './components/storage/photo-picker-component/photo-picker.factory';
import * as i28 from './components/storage/photo-picker-component/photo-picker.component.core';
import * as i29 from './components/interactions/chatbot/chatbot.factory';
import * as i30 from './components/interactions/chatbot/chatbot.component.core';
import * as i31 from './components/common/form.component';
import * as i32 from './components/xr/sumerian-scene-component/sumerian-scene.factory';
import * as i33 from './components/xr/sumerian-scene-component/sumerian-scene.component.core';
import * as i34 from './components/xr/sumerian-scene-component/sumerian-scene-loading.component.core';
export const AmplifyAngularModuleNgFactory:i0.NgModuleFactory<i1.AmplifyAngularModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_r = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_bd = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bf = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i4.DynamicComponentDirective = (<any>(null as any));
var _decl0_33:i5.AuthenticatorComponent = (<any>(null as any));
var _decl0_34:i6.AuthenticatorComponentCore = (<any>(null as any));
var _decl0_35:i7.ConfirmSignInComponent = (<any>(null as any));
var _decl0_36:i8.ConfirmSignInComponentCore = (<any>(null as any));
var _decl0_37:i9.ConfirmSignUpComponent = (<any>(null as any));
var _decl0_38:i10.ConfirmSignUpComponentCore = (<any>(null as any));
var _decl0_39:i11.SignInComponent = (<any>(null as any));
var _decl0_40:i12.SignInComponentCore = (<any>(null as any));
var _decl0_41:i13.SignUpComponent = (<any>(null as any));
var _decl0_42:i14.SignUpComponentCore = (<any>(null as any));
var _decl0_43:i15.RequireNewPasswordComponent = (<any>(null as any));
var _decl0_44:i16.RequireNewPasswordComponentCore = (<any>(null as any));
var _decl0_45:i17.GreetingComponent = (<any>(null as any));
var _decl0_46:i18.GreetingComponentCore = (<any>(null as any));
var _decl0_47:i19.ForgotPasswordComponent = (<any>(null as any));
var _decl0_48:i20.ForgotPasswordComponentCore = (<any>(null as any));
var _decl0_49:i21.UsernameFieldComponentCore = (<any>(null as any));
var _decl0_50:i22.PhoneFieldComponentCore = (<any>(null as any));
var _decl0_51:i23.S3AlbumComponent = (<any>(null as any));
var _decl0_52:i24.S3AlbumComponentCore = (<any>(null as any));
var _decl0_53:i25.S3ImageComponent = (<any>(null as any));
var _decl0_54:i26.S3ImageComponentCore = (<any>(null as any));
var _decl0_55:i27.PhotoPickerComponent = (<any>(null as any));
var _decl0_56:i28.PhotoPickerComponentCore = (<any>(null as any));
var _decl0_57:i29.ChatBotComponent = (<any>(null as any));
var _decl0_58:i30.ChatbotComponentCore = (<any>(null as any));
var _decl0_59:i31.FormComponent = (<any>(null as any));
var _decl0_60:i32.SumerianSceneComponent = (<any>(null as any));
var _decl0_61:i33.SumerianSceneComponentCore = (<any>(null as any));
var _decl0_62:i34.SumerianSceneLoadingComponentCore = (<any>(null as any));
var _decl0_63:i2.AsyncPipe = (<any>(null as any));
var _decl0_64:i2.UpperCasePipe = (<any>(null as any));
var _decl0_65:i2.LowerCasePipe = (<any>(null as any));
var _decl0_66:i2.JsonPipe = (<any>(null as any));
var _decl0_67:i2.SlicePipe = (<any>(null as any));
var _decl0_68:i2.DecimalPipe = (<any>(null as any));
var _decl0_69:i2.PercentPipe = (<any>(null as any));
var _decl0_70:i2.TitleCasePipe = (<any>(null as any));
var _decl0_71:i2.CurrencyPipe = (<any>(null as any));
var _decl0_72:i2.DatePipe = (<any>(null as any));
var _decl0_73:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_74:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_75:i2.CommonModule = (<any>(null as any));
var _decl0_76:i3.FormsModule = (<any>(null as any));
var _decl0_77:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_78:i0.ElementRef = (<any>(null as any));
function _View_AuthenticatorComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_AuthenticatorComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_AuthenticatorComponentCore_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_AuthenticatorComponentCore_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_34.shouldHide('SignIn');
  currVal_0;
  const currVal_1:any = !_decl0_34.shouldHide('SignUp');
  currVal_1;
  const currVal_2:any = !_decl0_34.shouldHide('ConfirmSignUp');
  currVal_2;
  const currVal_3:any = !_decl0_34.shouldHide('ConfirmSignIn');
  currVal_3;
  const currVal_4:any = !_decl0_34.shouldHide('ForgotPassword');
  currVal_4;
  const currVal_5:any = !_decl0_34.shouldHide('Greetings');
  currVal_5;
  const currVal_6:any = !_decl0_34.shouldHide('RequireNewPassword');
  currVal_6;
}
function _View_ConfirmSignInComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmSignInComponent_3_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmSignInComponentCore_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmSignInComponentCore_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_36._show;
  currVal_0;
}
function _View_ConfirmSignUpComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmSignUpComponent_5_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmSignUpComponentCore_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_ConfirmSignUpComponentCore_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_38._show;
  currVal_0;
}
function _View_SignInComponent_Host_7_0():void {
  var _any:any = (null as any);
}
function _View_SignInComponent_7_0():void {
  var _any:any = (null as any);
}
function _View_SignInComponentCore_Host_8_0():void {
  var _any:any = (null as any);
}
function _View_SignInComponentCore_8_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_40._show;
  currVal_0;
}
function _View_SignUpComponent_Host_9_0():void {
  var _any:any = (null as any);
}
function _View_SignUpComponent_9_0():void {
  var _any:any = (null as any);
}
function _View_SignUpComponentCore_Host_10_0():void {
  var _any:any = (null as any);
}
function _View_SignUpComponentCore_10_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_42._show;
  currVal_0;
}
function _View_RequireNewPasswordComponent_Host_11_0():void {
  var _any:any = (null as any);
}
function _View_RequireNewPasswordComponent_11_0():void {
  var _any:any = (null as any);
}
function _View_RequireNewPasswordComponentCore_Host_12_0():void {
  var _any:any = (null as any);
}
function _View_RequireNewPasswordComponentCore_12_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_44._show;
  currVal_0;
}
function _View_GreetingComponent_Host_13_0():void {
  var _any:any = (null as any);
}
function _View_GreetingComponent_13_0():void {
  var _any:any = (null as any);
}
function _View_GreetingComponentCore_Host_14_0():void {
  var _any:any = (null as any);
}
function _View_GreetingComponentCore_14_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_46.signedIn;
  currVal_0;
}
function _View_ForgotPasswordComponent_Host_15_0():void {
  var _any:any = (null as any);
}
function _View_ForgotPasswordComponent_15_0():void {
  var _any:any = (null as any);
}
function _View_ForgotPasswordComponentCore_Host_16_0():void {
  var _any:any = (null as any);
}
function _View_ForgotPasswordComponentCore_16_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_48._show;
  currVal_0;
}
function _View_UsernameFieldComponentCore_Host_17_0():void {
  var _any:any = (null as any);
}
function _View_UsernameFieldComponentCore_17_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_49._usernameAttributes === 'email');
  currVal_0;
  const currVal_1:any = (_decl0_49._usernameAttributes === 'phone_number');
  currVal_1;
  const currVal_2:any = ((_decl0_49._usernameAttributes !== 'email') && (_decl0_49._usernameAttributes !== 'phone_number'));
  currVal_2;
}
function _View_PhoneFieldComponentCore_Host_18_0():void {
  var _any:any = (null as any);
}
function _View_PhoneFieldComponentCore_18_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_50.amplifyService.i18n().get(_decl0_50._label);
  currVal_0;
  const currVal_1:any = _decl0_50._required;
  currVal_1;
  const currVal_2:any = 'countryCode';
  currVal_2;
  const currVal_3:any = _decl0_50._country_code;
  currVal_3;
  const currVal_4:any = _decl0_50._countries;
  currVal_4;
  const currVal_5:any = i0.ɵinlineInterpolate(1,'',_decl0_50.amplifyService.i18n().get(_decl0_50.getPlaceholder()),
      '');
  currVal_5;
  const pd_6:any = ((<any>(_decl0_50._country_code = _any)) !== false);
  const pd_7:any = ((<any>_decl0_50.setCountryCode(_any.target.value)) !== false);
  const pd_8:any = ((<any>_decl0_50.setLocalPhoneNumber(_any.target.value)) !== false);
}
function _View_S3AlbumComponent_Host_19_0():void {
  var _any:any = (null as any);
}
function _View_S3AlbumComponent_19_0():void {
  var _any:any = (null as any);
}
function _View_S3AlbumComponentCore_Host_20_0():void {
  var _any:any = (null as any);
}
function _View_S3AlbumComponentCore_20_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_52.list;
  currVal_0;
}
function _View_S3ImageComponent_Host_21_0():void {
  var _any:any = (null as any);
}
function _View_S3ImageComponent_21_0():void {
  var _any:any = (null as any);
}
function _View_S3ImageComponentCore_Host_22_0():void {
  var _any:any = (null as any);
}
function _View_S3ImageComponentCore_22_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'',_decl0_54.url,'');
  currVal_0;
  const pd_1:any = ((<any>_decl0_54.onImageClicked()) !== false);
}
function _View_PhotoPickerComponent_Host_23_0():void {
  var _any:any = (null as any);
}
function _View_PhotoPickerComponent_23_0():void {
  var _any:any = (null as any);
}
function _View_PhotoPickerComponentCore_Host_24_0():void {
  var _any:any = (null as any);
}
function _View_PhotoPickerComponentCore_24_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_56.hasPhoto;
  currVal_0;
  const currVal_1:any = _decl0_56.hasPhoto;
  currVal_1;
  const currVal_2:any = _decl0_56.hasPhoto;
  currVal_2;
  const currVal_3:any = _decl0_56.errorMessage;
  currVal_3;
  const pd_4:any = ((<any>_decl0_56.pick(_any)) !== false);
}
function _View_ChatBotComponent_Host_25_0():void {
  var _any:any = (null as any);
}
function _View_ChatBotComponent_25_0():void {
  var _any:any = (null as any);
}
function _View_ChatbotComponentCore_Host_26_0():void {
  var _any:any = (null as any);
}
function _View_ChatbotComponentCore_26_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_58.messages;
  currVal_0;
  const currVal_1:any = _decl0_58.textEnabled;
  currVal_1;
  const currVal_2:any = !_decl0_58.textEnabled;
  currVal_2;
  const currVal_3:any = _decl0_58.voiceEnabled;
  currVal_3;
  const currVal_4:any = _decl0_58.textEnabled;
  currVal_4;
}
function _View_FormComponent_Host_27_0():void {
  var _any:any = (null as any);
}
function _View_FormComponent_27_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_59.title;
  currVal_0;
}
function _View_SumerianSceneComponent_Host_28_0():void {
  var _any:any = (null as any);
}
function _View_SumerianSceneComponent_28_0():void {
  var _any:any = (null as any);
}
function _View_SumerianSceneComponentCore_Host_29_0():void {
  var _any:any = (null as any);
}
function _View_SumerianSceneComponentCore_29_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'',_decl0_61.amplifyUI.sumerianSceneContainer,
      '');
  currVal_0;
  const currVal_1:any = i0.ɵinlineInterpolate(1,'',_decl0_61.amplifyUI.sumerianScene,
      '');
  currVal_1;
  const currVal_2:any = _decl0_61.loading;
  currVal_2;
  const currVal_3:any = !_decl0_61.loading;
  currVal_3;
}
function _View_SumerianSceneLoadingComponentCore_Host_30_0():void {
  var _any:any = (null as any);
}
function _View_SumerianSceneLoadingComponentCore_30_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'',_decl0_62.AmplifyUI.loadingOverlay,
      '');
  currVal_0;
  const currVal_1:any = i0.ɵinlineInterpolate(1,'',_decl0_62.AmplifyUI.loadingContainer,
      '');
  currVal_1;
  const currVal_2:any = i0.ɵinlineInterpolate(1,'',_decl0_62.AmplifyUI.loadingLogo,
      '');
  currVal_2;
  const currVal_3:any = i0.ɵinlineInterpolate(1,'',_decl0_62.AmplifyUI.loadingSceneName,
      '');
  currVal_3;
  const currVal_4:any = _decl0_62.sceneName;
  currVal_4;
  const currVal_5:any = _decl0_62.sceneError;
  currVal_5;
  const currVal_6:any = !_decl0_62.sceneError;
  currVal_6;
}
